'use client'

import styles from './styles.module.css'
import { Breadcrumbs } from '../_components/Breadcrumps'
import { PropsWithChildren } from 'react'

export default function ServicesLayout({ children }: PropsWithChildren) {
	return (
		<>
			<Breadcrumbs className={styles.breadcrumps} />
			<main className={styles.main}>{children}</main>
		</>
	)
}
